import base  from "./base_controller";
import payments_index from "./controller_actions/payments_index";
App.controller.payments = class payments_controller extends base {
    constructor() {
        super();
    }
    index(){
        App.main.payments.index = new payments_index();
    }
}
